module.exports = {
    MAIN: 'main',
    MY: 'my',
    SATELITE: 'satelite',
    ALL: 'all',
};
